@if (isSaving) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
<mat-card>
  <mat-card-header>
    <h2>Add new Infringement</h2>
  </mat-card-header>
  <mat-card-content>

    <form [formGroup]="infringementDetails" (ngSubmit)="onSubmit()">

      <div style="display: flex; gap: 16px; margin-bottom: 16px;">
        <!-- Identifier Preview (read-only, auto-generated by backend) -->
        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Identifier (auto-generated)</mat-label>
          <input matInput [value]="previewedIdentifier ?? ''" readonly disabled>
          <mat-hint *ngIf="isLoadingIdentifier">Loading preview...</mat-hint>
          <mat-hint *ngIf="!isLoadingIdentifier && previewedIdentifier">Preview — final identifier assigned on save</mat-hint>
        </mat-form-field>

        <!-- Radiobutton-Gruppe für Infringement-Typ -->
        <div style="flex: 1; display: flex; align-items: center;">
          <mat-radio-group formControlName="infringementType" style="display: flex; flex-direction: row;">
            <mat-radio-button value="0" style="margin-right: 16px;">
              IP-Infringement
            </mat-radio-button>
            <mat-radio-button value="1">
              Contract Breach
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Company</mat-label>
        <mat-select (selectionChange)="onCompanySelected($event.value)" matInput formControlName="accusedCompany"
                    required>
          <!-- "New Company" Option -->
          <mat-option [value]="'new'">New Company</mat-option>
          <!-- Use async pipe to display companies -->
          <mat-option *ngFor="let company of companies" [value]="company">
            {{ company.name }}
          </mat-option>

        </mat-select>
        <mat-error *ngIf="infringementDetails.get('accusedCompany')?.hasError('required')">
          Identifier is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Accused Name</mat-label>
        <input
          matInput
          formControlName="accusedName"
          [matAutocomplete]="companyNameSuggestions"
          (input)="onAccusedNameInput()"
          (blur)="onAccusedNameBlur()"/>
        <mat-autocomplete
          #companyNameSuggestions="matAutocomplete">
          <mat-option *ngFor="let company of filteredCompanies" [value]="company.name">
            {{ company.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Accused URL</mat-label>
        <input matInput formControlName="accusedURL"/>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Accused Email</mat-label>
        <input matInput formControlName="accusedEmail"/>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Accused Country</mat-label>
        <mat-select formControlName="accusedCountry">
          <mat-option *ngFor="let country of countries | keyvalue" [value]="country.key">
            <img width="15" height="10" alt="${ country.key } flag"
                 [attr.src]="'https://flagcdn.com/h20/' + country.key.toLowerCase() + '.png'">  {{ country.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Responsible Employee</mat-label>
        <input matInput formControlName="responsibleEmployee"/>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Further Details</mat-label>
        <input matInput formControlName="infringementDetails"/>
      </mat-form-field>


      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="isSaving">
        Save
      </button>
    </form>
  </mat-card-content>
